import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { useTools } from '@risksmart-app/components/src/tools/useTools';
import {
  Assessment_Activity_Status_Enum,
  Assessment_Activity_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUpdateAssessmentActivityWithLinkedItems } from '@/hooks/mutations/assessment-activity/useUpdateAssessmentActivityWithLinkedItems';
import { useDeleteWizard } from '@/hooks/mutations/wizard';
import { handleError } from '@/utils/errorUtils';

import { useWizardStore } from '../store/useWizardStore';
import { StepStatus } from '../types';

export const useCloseWizard = (riskId: string) => {
  const {
    setCurrentStep,
    steps,
    setSteps,
    risk,
    assessmentId,
    activityId,
    setWizardStatus,
    setAssessmentId,
    setActivityId,
  } = useWizardStore();
  const [_, setToolsContent] = useTools();
  const { t } = useTranslation('common', { keyPrefix: 'wizard' });
  const { user } = useRisksmartUser();
  const { addNotification } = useNotifications();

  const [loading, setIsLoading] = useState(false);

  const { deleteWizard } = useDeleteWizard();

  const { updateAssessmentActivity } =
    useUpdateAssessmentActivityWithLinkedItems();

  return {
    closeWizard: async (isLastStep = false) => {
      const inProgressStep = steps?.findIndex(
        (step) => step.status === StepStatus.InProgress
      );
      if (isLastStep) {
        setIsLoading(true);
        try {
          await deleteWizard({ RiskId: riskId });
        } catch (error) {
          handleError(error);
          addNotification({
            type: 'error',
            content: (
              <>{error instanceof Error ? error.message : 'Unknown error'}</>
            ),
          });
        }
        await updateAssessmentActivity({
          Id: activityId,
          Title: `${t('wizardName')} - ${risk.title}`,
          Status: Assessment_Activity_Status_Enum.Complete,
          ActivityType: Assessment_Activity_Type_Enum.Task,
          Summary: `${t('wizardName')} - ${risk.title}`,
          LinkedItemIds: [riskId],
          ParentId: assessmentId,
          CompletionDate: new Date().toISOString(),
          IsWizardAction: true,
          OwnerUserIds: [user!.userId],
          OwnerGroupIds: [],
        });
        setSteps(t('steps'));
        setCurrentStep(0);
        setWizardStatus(null);
        setAssessmentId('');
        setActivityId('');
        setIsLoading(false);
      } else {
        setCurrentStep(inProgressStep);
      }

      setToolsContent(undefined);
    },
    loading,
  };
};
